if (!customElements.get("product-form")) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      // elements
      this.form = this.querySelector("form");
      this.fakeSubmitButton = this.querySelector("[data-fake-submit-button]");
      this.cartNotification = document.querySelector("cart-notification");
      this.cartDrawer = document.querySelector("cart-drawer");

      // event listeners
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      if (this.fakeSubmitButton) {
        this.fakeSubmitButton.addEventListener(
          "click",
          this.handleError.bind(this)
        );
      }
    }

    handleError() {
      // get the variant radios wrapper
      const variantRadios = document.querySelector("variant-radios");
      if (variantRadios) {
        // get the variant options wrapper
        const variants = variantRadios.querySelectorAll("fieldset");

        let variantSelected = true;

        variants.forEach((variant) => {
          // get the variant error element
          const variantError = variant.querySelector("[data-variant-error]");
          const variantErrorMobile = document.querySelector(
            "[data-variant-error-mobile]"
          );
          // get the variant options
          const options = variant.querySelectorAll('input[type="radio"]');
          // get the selected option
          const selectedOption = Array.from(options).find(
            (option) => option.checked
          );

          if (!selectedOption) {
            variantError.classList.add(
              "product-variant-selector--error-visible"
            );
            variantErrorMobile.classList.add(
              "product-variant-selector--error-visible"
            );
            variantSelected = false;
          }
        });

        if (!variantSelected) {
          return;
        }
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      submitButton.setAttribute("disabled", true);
      submitButton.classList.add("loading");

      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const sectionsToFetch = [
        ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
        ...this.cartNotification
          .getSectionsToRender()
          .map((section) => section.id),
      ];

      const formData = new FormData(this.form);
      formData.append("sections", sectionsToFetch);
      formData.append("sections_url", window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status == 422) {
            // When quantity error
            this.cartNotification.setActiveElement(document.activeElement);
            this.cartNotification.renderQuantityError(
              formData.get("inventory_quantity")
            );
            return;
          }

          this.cartDrawer.renderContents(parsedState);

          switch (submitButton.dataset.addToCartBehavior) {
            case "open_cart_drawer":
              this.cartDrawer.open();
              break;
            case "show_cart_notification":
            default:
              this.cartNotification.setActiveElement(document.activeElement);
              this.cartNotification.renderContents(parsedState);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove("loading");
          submitButton.removeAttribute("disabled");
        });
    }
  }

  window.ProductForm = ProductForm;
  customElements.define("product-form", ProductForm);
}
